webpackJsonp([81],{

/***/ "ToFj":
/***/ (function(module, exports, __webpack_require__) {

var SectionVideoSignUp = (function () {
    SectionVideoSignUp.$inject = ["$stateParams"];
    function SectionVideoSignUp($stateParams) {
        this.$stateParams = $stateParams;
        this.ltTitle = this.$stateParams.t || this.ltTitle;
        this.description = this.$stateParams.d || this.description;
        this.logo = _.isBoolean(this.logo) ? this.logo : true;
    }
    return SectionVideoSignUp;
}());
angular.module('animatronApp.sectionVideoSignUp', []).component('sectionVideoSignUp', {
    bindings: {
        logo: '<',
        ltTitle: '<',
        description: '<',
        button: '<',
        background: '<',
        image: '<',
        video: '<',
        isScrollButton: '<'
    },
    controller: SectionVideoSignUp,
    templateUrl: __webpack_require__("WUbV")
});


/***/ }),

/***/ "WUbV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-video-sign-up_8198953f3ba2208b76d48b5d2fbd720f.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/81-257c10c0995a4d25fa59.min.js